var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeployementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5926 93.8244C73.5016 93.8244 94.4633 72.8211 94.4119 46.9122C94.3604 21.0033 73.3154 0 47.4064 0C21.4975 0 0.535822 21.0033 0.587239 46.9122C0.638656 72.8211 21.6837 93.8244 47.5926 93.8244Z",
    fill: "url(#paint0_linear_3216_8452)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36914 46.7512C6.36914 24.091 24.8019 5.6582 47.4621 5.6582C70.1224 5.6582 88.5551 24.091 88.5551 46.7512C88.5551 69.4114 70.1224 87.8442 47.4621 87.8442C24.8019 87.8442 6.36914 69.4114 6.36914 46.7512Z",
    fill: "#1EBBD7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3216_8452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7457 40.5742H47.4023V52.6646H48.7457V40.5742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5515 40.0956C48.2912 39.8353 47.863 39.8353 47.6028 40.0956L44.916 42.7823L45.8648 43.7311L48.0729 41.5229L50.2811 43.7395L51.2383 42.7823L48.5515 40.0956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1182 45.2773C51.465 45.2773 50.7598 47.0321 50.7598 47.9641V50.6508H52.1031V47.9641C52.1031 47.9053 52.1283 46.6207 54.1182 46.6207H61.5067V45.2773H54.1182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5515 40.0956C48.2912 39.8353 47.863 39.8353 47.6028 40.0956L44.916 42.7823L45.8648 43.7311L48.0729 41.5229L50.2811 43.7395L51.2383 42.7823L48.5515 40.0956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9851 45.4875L59.2984 42.8008L58.3496 43.7495L60.5578 45.9577L58.3496 48.1659L59.2984 49.1146L61.9851 46.4363C62.2454 46.176 62.2454 45.7478 61.9851 45.4875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9851 45.4875L59.2984 42.8008L58.3496 43.7495L60.5578 45.9577L58.3496 48.1659L59.2984 49.1146L61.9851 46.4363C62.2454 46.176 62.2454 45.7478 61.9851 45.4875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0292 45.2773H34.6406V46.6207H42.0292C43.9099 46.6207 44.0358 47.7458 44.0442 47.9641V49.3075H45.3876V47.9641C45.3876 47.0321 44.6823 45.2773 42.0292 45.2773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7975 43.7398L36.8488 42.791L34.162 45.4778C33.9017 45.738 33.9017 46.1662 34.162 46.4265L36.8488 49.1133L37.7975 48.1561L35.5893 45.9479L37.7975 43.7398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7975 43.7398L36.8488 42.791L34.162 45.4778C33.9017 45.738 33.9017 46.1662 34.162 46.4265L36.8488 49.1133L37.7975 48.1561L35.5893 45.9479L37.7975 43.7398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.82 55.3526H52.1031V51.9941H50.7598V55.3526C50.7598 55.3778 50.7598 55.3946 50.7598 55.4113C50.7766 56.1334 51.3727 56.7127 52.1031 56.6959H58.82V60.0544H60.1634V56.6959C60.1634 56.6708 60.1634 56.654 60.1634 56.6372C60.1466 55.9151 59.5505 55.3358 58.82 55.3526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.043 50.6523V55.3541H37.3262C37.301 55.3541 37.2842 55.3541 37.2674 55.3541C36.5453 55.3709 35.966 55.9671 35.9828 56.6975V60.0559H37.3262V56.6975H44.043C44.0682 56.6975 44.085 56.6975 44.1018 56.6975C44.8238 56.6807 45.4032 56.0846 45.3864 55.3541V50.6523H44.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4315 59.3828H44.7147C44.3452 59.3828 44.043 59.6851 44.043 60.0545V66.7714C44.043 67.1408 44.3452 67.443 44.7147 67.443H51.4315C51.8009 67.443 52.1032 67.1408 52.1032 66.7714V60.0545C52.1032 59.6851 51.8009 59.3828 51.4315 59.3828ZM50.7598 66.0997H45.3863V60.7262H50.7598V66.0997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8514 59.3828H56.1346C55.7651 59.3828 55.4629 59.6851 55.4629 60.0545V66.7714C55.4629 67.1408 55.7651 67.443 56.1346 67.443H62.8514C63.2209 67.443 63.5231 67.1408 63.5231 66.7714V60.0545C63.5231 59.6851 63.2209 59.3828 62.8514 59.3828ZM62.1798 66.0997H56.8063V60.7262H62.1798V66.0997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0155 59.3828H33.2986C32.9292 59.3828 32.627 59.6851 32.627 60.0545V66.7714C32.627 67.1408 32.9292 67.443 33.2986 67.443H40.0155C40.3849 67.443 40.6872 67.1408 40.6872 66.7714V60.0545C40.6872 59.6851 40.3849 59.3828 40.0155 59.3828ZM39.3438 66.0997H33.9703V60.7262H39.3438V66.0997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5329 59.5843L32.8184 66.2988L33.7683 67.2487L40.4828 60.5342L39.5329 59.5843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9528 59.5823L44.2383 66.2969L45.1882 67.2468L51.9027 60.5322L50.9528 59.5823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3727 59.5823L55.6582 66.2969L56.6081 67.2468L63.3226 60.5322L62.3727 59.5823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7457 54.0078H47.4023V60.053H48.7457V54.0078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4244 36.8143C60.8031 30.4333 55.757 25.3872 49.376 24.7659C42.0043 24.0439 35.4385 29.4426 34.7249 36.8143C30.1322 37.125 26.5723 40.9368 26.5723 45.5378C26.5807 50.3572 30.4932 54.2614 35.3126 54.2614H37.2857V52.918H35.3126C31.2321 52.9096 27.9324 49.5931 27.9408 45.5126C27.9492 41.4321 31.2657 38.1325 35.3462 38.1409C35.7072 38.1409 36.0011 37.8638 36.0179 37.5028C36.3453 31.3401 41.2654 26.4116 47.4365 26.0841C54.0946 25.7315 59.7787 30.8447 60.1314 37.5028C60.165 37.8638 60.4756 38.1409 60.8367 38.1409C64.9171 38.1409 68.2252 41.4489 68.2252 45.5294C68.2252 49.6099 64.9171 52.918 60.8367 52.918H58.8888V54.2614H60.8367C65.4377 54.2697 69.2495 50.7014 69.5518 46.1088C69.8792 41.2978 66.2353 37.1334 61.4244 36.8143Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3216_8452",
    x1: 52.592,
    y1: -6.0847,
    x2: 41.8907,
    y2: 103.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3216_8452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "white",
    transform: "translate(26.5723 24.5723)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployementIcon);
export default __webpack_public_path__ + "static/media/deployementIcon.56a5cef72828935924bbe85a6d084129.svg";
export { ForwardRef as ReactComponent };